<template>
  <div
    class="d-flex flex-column min-vh-100 vh-100"
    data-spy="scroll"
    data-target="#mainNav"
    data-offset="75"
  >
    <navigation-main />
    {{ $route.params.code }}
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section bg-light">
            <div class="container">
              <div :class="{ 'd-none': doneChecking }">
                <h3>Verifying user</h3>
                <div id="loader"></div>
              </div>

              <div :class="{ 'd-none': !doneChecking || confirmationFailed }">
                <div class="card m-3">
                  <div class="card-header">
                    <h2>Successfully Confirmed</h2>
                  </div>
                  <div class="card-body">
                    <h1>Your registration is complete</h1>
                    <router-link to="/login" class="btn btn-link"
                      >Login</router-link
                    >
                  </div>
                </div>
              </div>

              <div :class="{ 'd-none': !doneChecking || !confirmationFailed }">
                <div class="card m-3">
                  <div class="card-header">
                    <h2>Error with confirmation</h2>
                  </div>
                  <div class="card-body">
                    <h1>User could not be activated</h1>
                    <router-link to="/register" class="btn btn-link"
                      >Register
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  components: { NavigationMain },
  name: "ConfirmUser",
  data() {
    return {
      doneChecking: false,
      confirmationFailed: true
    };
  },
  methods: {
    ...mapActions("api", ["activateUser"]),
    activateWithCode(code) {
      this.activateUser({ code }).then(
        response => {
          console.log(response);
          this.doneChecking = true;
          this.confirmationFailed = false;
          // Navigate to login
          this.$router.push("/login");
        },
        () => {
          this.doneChecking = true;
          this.confirmationFailed = true;
        }
      );
      console.log("activate");
    }
  },
  watch: {},
  mounted() {
    const code = this.$route.fullPath.split("/")[
      this.$route.fullPath.split("/").length - 1
    ];
    console.log(code);
    if (!code) {
      this.doneChecking = true;
      this.confirmationFailed = true;
      return;
    }
    this.activateWithCode(code);
  }
};
</script>

<style scoped>
/* Center the loader */
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
